import { render } from "./advisorInsightsOverview.vue?vue&type=template&id=db36d71e&scoped=true&ts=true"
import script from "./advisorInsightsOverview.vue?vue&type=script&lang=ts"
export * from "./advisorInsightsOverview.vue?vue&type=script&lang=ts"

import "./advisorInsightsOverview.vue?vue&type=style&index=0&id=db36d71e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db36d71e"]])

export default __exports__